import { FlowType } from '@jerry-serverless/types';

import type { Step } from '../../types/step';
import type { AppData } from '../../../types/app_data';
import { StepCategory } from '../../../types/app_data';
import { getPartnerWelcomePageType, PartnerWelcomePageType } from '../../../utils/partner';
import { growthBookInstance } from '../../../utils/analytics/growthbook';
import { ABTestCarValueCombineNameAndPhone } from '../../../utils/enabled_features/ab_tests';

export const PhoneStep: Step = {
  id: 'phone',
  pathname: '/phone',
  canShow: (appData: AppData) => {
    if (appData.flowType === FlowType.CarValue) {
      const abtestVariation = growthBookInstance?.getFeatureValue(ABTestCarValueCombineNameAndPhone.storageKey, 0);
      if ((abtestVariation ?? 0) > 0) return false;
    }
    // WelcomeLanding is almost same as Phone screen, if WelcomeLanding is shown, we don't need to show Phone screen
    return (
      getPartnerWelcomePageType(appData) !== PartnerWelcomePageType.WelcomeLanding &&
      !appData.phoneVerified &&
      !appData.isOnboardingLite
    );
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => !!appData.phone && !!appData.signupUserSuccess,
  category: () => StepCategory.GarageOnlyAccount,
};
